exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */.m-column:not(:first-child){margin-left:45px}.m-column-row .m-field:not(:first-child){margin-left:45px}.absolute-button{position:absolute;top:-14px}:host .mat-form-field.half{max-width:185px}", ""]);

// exports
